import React from 'react';
import { useTranslation } from 'react-i18next';
import { Registry } from './registry.jsx';
import { NodePropsForm } from './NodePropsForm.jsx';

export function NodeSettingsModal({ node, onChange, onClose, currentPageId, activeTab, onTabChange, isNewsletterEditor }){
  const { t } = useTranslation();
  const [internalTab, setInternalTab] = React.useState('props'); // 'props' | 'style' | 'advanced'
  const tab = activeTab || internalTab;
  const setTab = onTabChange || setInternalTab;
  if(!node) return null;
  const Comp = Registry[node.type] || (({children})=> <div>{children}</div>);
	return (
		<div className="w-full h-full flex flex-col" onClick={(e)=> e.stopPropagation()}>
			<div className="px-4 py-3 border-b flex items-center justify-between">
				<div className="font-semibold text-sm">Einstellungen · {node.type}</div>
				{onClose && (
					<button className="text-xs px-2 py-1 rounded border bg-background hover:bg-slate-50" onClick={onClose}>{t('common.close')}</button>
				)}
			</div>
			<div className="flex-1 overflow-auto">
				{/* Tabs und Formular – Preview wurde entfernt, Tabs kommen jetzt nur hier vor */}
				<div className="px-4 pt-3 pb-2 border-b text-[11px] flex gap-2 sticky top-0 bg-background z-10">
					<button onClick={()=>setTab('props')} className={`px-2 py-1 rounded ${tab==='props'?'bg-slate-200':'hover:bg-slate-50'}`}>Inhalt</button>
					<button onClick={()=>setTab('style')} className={`px-2 py-1 rounded ${tab==='style'?'bg-slate-200':'hover:bg-slate-50'}`}>Stil</button>
					<button onClick={()=>setTab('advanced')} className={`px-2 py-1 rounded ${tab==='advanced'?'bg-slate-200':'hover:bg-slate-50'}`}>Erweitert</button>
				</div>
				<div className="p-3">
					{tab==='props' && <NodePropsForm node={node} onChange={onChange} sections={{ style:false, advanced:false }} currentPageId={currentPageId} isNewsletterEditor={isNewsletterEditor} />}
					{tab==='style' && <NodePropsForm node={node} onChange={onChange} sections={{ props:false, advanced:false }} currentPageId={currentPageId} isNewsletterEditor={isNewsletterEditor} />}
					{tab==='advanced' && <NodePropsForm node={node} onChange={onChange} sections={{ props:false, style:false, advanced:true }} currentPageId={currentPageId} isNewsletterEditor={isNewsletterEditor} />}
				</div>
			</div>
		</div>
	);
}

export default NodeSettingsModal;
